import { useEffect, useId, useMemo, useRef } from "react";
import { XIcon } from 'lucide-react';
import { HUBSPOT_FORMS } from "../../../constants";

const PORTAL_ID = "441787855";
const HS_SCRIPT_ID = "hs-forms-script";

function loadHubspot() {
    return new Promise((resolve, reject) => {
        if (window.hbspt && window.hbspt.forms && window.hbspt.forms.create) {
            return resolve(window.hbspt);
        }
        let script = document.getElementById(HS_SCRIPT_ID);
        if (!script) {
            script = document.createElement("script");
            script.id = HS_SCRIPT_ID;
            script.src = "https://js.hsforms.net/forms/v2.js";
            script.async = true;
            script.onerror = () => reject(new Error("Failed to load HubSpot forms script"));
            document.body.appendChild(script);
        }
        script.addEventListener(
            "load",
            () => {
                if (window.hbspt && window.hbspt.forms && window.hbspt.forms.create) {
                    resolve(window.hbspt);
                } else {
                    reject(new Error("HubSpot loaded but hbspt is unavailable"));
                }
            },
            { once: true }
        );
    });
}

const HubspotForm = ({ showForm, setShowForm, formKey }) => {
    const formId = HUBSPOT_FORMS[formKey];
    const uid = useId();
    const containerId = useMemo(
        () => `hs-form-${formKey}-${uid.replace(/:/g, "")}`,
        [formKey, uid]
    );
    const createdRef = useRef(false);

    useEffect(() => {
        if (!showForm || createdRef.current) return;

        let cancelled = false;

        loadHubspot()
            .then((hbspt) => {
                if (cancelled) return;
                const opts = {
                    portalId: PORTAL_ID,
                    formId,
                    target: `#${containerId}`,
                };
                hbspt.forms.create(opts);
                createdRef.current = true;
            })
            .catch((err) => {
                console.error("HubSpot form load/create failed:", err);
            });

        // Don't remove the global script (other instances may use it).
        // Just clear this instance's container on unmount.
        return () => {
            cancelled = true;
            const el = document.getElementById(containerId);
            if (el) el.innerHTML = "";
            createdRef.current = false;
        };
    }, [showForm, containerId, formId]);


    if (!showForm) return null;

    return (
        <div className="fixed inset-0 bg-black/30 bg-opacity-50 flex justify-center items-start z-[99] overflow-auto" >
            <div className="bg-white rounded-lg shadow-lg mt-5 mb-5 py-6 w-11/12 md:w-3/4 lg:w-1/2">
                <div className="flex justify-end items-center mb-4">
                    <button
                        onClick={() => setShowForm(false)}
                        className="text-gg-dark text-2xl font-bold w-10 h-10 mr-4 cursor-pointer flex items-center justify-center rounded-full hover:bg-gg-cream"
                    >
                        <XIcon />
                    </button>
                </div>
                <div id={containerId}></div>
            </div>
        </div >
    );

};

export default HubspotForm;
